import { ChangeDetectorRef, Component, Input, OnChanges } from "@angular/core";
import Swal from "sweetalert2";

import { PinAutorizadorService } from "./pin-autorizador.service";
import { PinAutorizadorRes } from "../../shared/model/security/pin-autorizador.model";

/**
 * «Restablecer PIN de autorización» en Personas › Empleados, al editar a
 * alguien que tiene PIN. Borra el PIN: la persona define uno nuevo en
 * Ajustes, con su contraseña de COS. No existe «ver el PIN».
 *
 * Si quien edita no administra Empleados (el servidor lo revisa en
 * estado.do), no se pinta nada.
 */
@Component({
  selector: "app-pin-restablecer",
  standalone: true,
  templateUrl: "./pin-restablecer.component.html",
  styleUrls: ["./pin-restablecer.component.css"],
})
export class PinRestablecerComponent implements OnChanges {
  @Input() idUsuario?: number | null;
  @Input() nombre?: string | null;

  estado: PinAutorizadorRes | null = null;
  enviando = false;
  /** Lo que queda escrito tras restablecer. */
  hecho = "";

  constructor(
    private service: PinAutorizadorService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(): void {
    this.estado = null;
    this.hecho = "";
    const id = this.idUsuario;
    if (id == null || id <= 0) {
      return;
    }
    this.service.estado(id).subscribe({
      next: (res) => {
        if (this.idUsuario === id) {
          this.estado = res.codigoError ? null : res;
          this.cdr.markForCheck();
        }
      },
      error: () => {
        this.estado = null;
        this.cdr.markForCheck();
      },
    });
  }

  get quien(): string {
    return (this.nombre || "").trim() || "Esta persona";
  }

  restablecer(): void {
    const id = this.idUsuario;
    // Un toast (el de un intento anterior) no cuenta como cuadro abierto.
    const popup = Swal.getPopup();
    if (id == null || this.enviando || !this.estado?.tienePin
      || (Swal.isVisible() && !!popup && !popup.classList.contains("swal2-toast"))) {
      return;
    }
    // titleText y text: Swal pinta title y html como HTML.
    Swal.fire({
      titleText: "¿Restablecer el PIN de autorización?",
      text: `${this.quien} tendrá que definir uno nuevo en Ajustes, con su contraseña de COS, antes de volver a firmar. `
        + "Queda en la bitácora del PIN con tu nombre.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Restablecer",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#b3261e",
    }).then((x) => {
      if (!x.isConfirmed || this.idUsuario !== id) {
        return;
      }
      this.enviando = true;
      this.cdr.markForCheck();
      this.service.restablecer(id).subscribe({
        next: (res) => {
          this.enviando = false;
          if (res.codigoError) {
            this.avisa(res.mensajeError || "No se pudo restablecer el PIN.", "error");
          } else {
            this.estado = res;
            this.hecho = `PIN restablecido: ${this.quien} define uno nuevo en Ajustes.`;
            this.avisa("PIN restablecido; quedó en la bitácora.", "success");
          }
          this.cdr.markForCheck();
        },
        error: () => {
          this.enviando = false;
          this.avisa("No se pudo restablecer el PIN: sin conexión con el servidor.", "error");
          this.cdr.markForCheck();
        },
      });
    });
  }

  private avisa(texto: string, icono: "success" | "error"): void {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: icono,
      titleText: texto,
      showConfirmButton: false,
      timer: icono === "error" ? 6000 : 2500,
      timerProgressBar: true,
    });
  }
}
